defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/ClubSettings/SettingsOptionsItem',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/LoadingRing'

  ],
  function (m, PlayTogetherApi, LoadingRing) {
    var SettingsOptionsItem = {
      controller: function ({ controller, option }) {
        Object.assign(this, controller);
        this.isProcessing = m.prop(false);

        this.toggleSetting = () => {
          if (this.mode === 'edit') {
            this.isProcessing(true);

            const payload = { ...this.clubModel().toJSON() };
            payload.rules[option](!this.clubSettings()[option]());

            PlayTogetherApi.updateClub(this.clubId(), payload)
              .then((response) => {
                this.isProcessing(false);
                this.clubSettings()[option](response?.rules?.[option]);
                this.clubModel().save();
                m.redraw();
              })
              .catch((response) => {
                this.isProcessing(false);
                this.error(response);
                m.redraw();
              });
          } else {
            this.clubSettings()[option](!this.clubSettings()[option]());
            this.clubModel().save();
          }

          this.trackSettingChange();
        };
      },
      view: function (controller, { option }) {
        const className = () => {
          let className = '';
          const toggleState = () => {
            if (option === 'isOpenForRegistration') {
              return !controller.clubSettings()[option]();
            }
            return controller.clubSettings()[option]();
          };

          if (toggleState()) {
            className += 'play-together__toggle-switch--is-on';
          }
          if (controller.isProcessing()) {
            className += ' play-together__toggle-switch--processing';
          }

          return className;
        };
        return m('.play-together__settings-option', [
          m('.play-together__settings-option-label', controller.settingsOptionsLabels[option]),
          m('.play-together__toggle-switch', {
            class: className(),
            onclick: controller.toggleSetting
          }, m('.play-together__toggle-switch-dot', LoadingRing()))
        ]);
      }
    };

    // Public functions:
    return SettingsOptionsItem;
  });
